//
// This is the main app js.
//

import App from './App.svelte';
import 'bulma/css/bulma.css';

const app = new App({
	target: document.body
});

export default app;
